import { useQuery } from "@tanstack/react-query";
import React from "react";
import { useParams } from "react-router-dom";
import Weather from "./Weather";

export interface EmployeeProp {
  include_in_rotation: boolean;
  name: string;
  photo: {
    url: string;
  };
  text: string;
  content: {
    heading_1: string;
    text_1: string;
    heading_2: string;
    text_2: string;
    heading_3: string;
    text_3: string;
  };
}

export default function Employee(props: { employee?: EmployeeProp }) {
  const match = useParams<{ community: string }>();
  const optionsQuery = useQuery({
    queryKey: ["options", match.community],
    queryFn: async () => {
      const res = await fetch(`https://calyxseniorliving.com/wp-json/options/all`);
      const json = await res.json();
      // console.log("json", json);
      return json[match.community];
    },
    enabled: !props.employee,
  });
  const employee: EmployeeProp = optionsQuery?.data || props.employee;

  console.log("employee", employee);

  return (
    <React.Fragment>
      <header className="header header--week">
        <div className="header__logo">
          <img src={`/img/logo-stacked.png`} alt="logo" />
        </div>
        <h1 className="header__title">
          <strong>Team Member of the Month</strong>
        </h1>
        <div className="header__weather">
          <Weather />
        </div>
      </header>
      <div
        className="flex mx-4"
        style={{
          height: "calc(100vh - 120px)",
        }}
      >
        <div className="flex-1 p-3">
          {employee?.photo.url && (
            <img
              src={employee.photo.url}
              alt={employee.name}
              className="employee-photo w-full h-full object-cover"
            />
          )}
        </div>
        <div className="flex-1">
          <header className="header">
            <h1 className="text-4xl pt-2 pb-1 text-blueDark mx-auto font-bold">{employee?.name}</h1>
          </header>

          {employee?.content.heading_1 && (
            <div className="text-center text-2xl flex-1 text-blueDark px-12 relative quote-container mb-8">
              <img src="/img/quote.svg" alt="quote open" className="w-12 h-12 absolute left-6" />

              <div className="px-10">
                <p className="">
                  <strong>{employee?.content.heading_1}</strong>
                  <br />
                  {employee?.content.text_1}
                </p>
              </div>

              <img
                src="/img/quote.svg"
                alt="quote open"
                className="w-12 h-12 absolute right-6 -bottom-4 rotate-180"
              />
            </div>
          )}

          {employee?.content.heading_2 && (
            <div className="text-center text-2xl flex-1 text-blueDark px-12 relative quote-container mb-8">
              <img src="/img/quote.svg" alt="quote open" className="w-12 h-12 absolute left-6" />

              <div className="px-10">
                <p className="">
                  <strong>{employee?.content.heading_2}</strong>
                  <br />
                  {employee?.content.text_2}
                </p>
              </div>

              <img
                src="/img/quote.svg"
                alt="quote open"
                className="w-12 h-12 absolute right-6 -bottom-4 rotate-180"
              />
            </div>
          )}

          {employee?.content.heading_3 && (
            <div className="text-center text-2xl flex-1 text-blueDark px-12 relative quote-container mb-8">
              <img src="/img/quote.svg" alt="quote open" className="w-12 h-12 absolute left-6" />

              <div className="px-10">
                <p className="">
                  <strong>{employee?.content.heading_3}</strong>
                  <br />
                  {employee?.content.text_3}
                </p>
              </div>

              <img
                src="/img/quote.svg"
                alt="quote open"
                className="w-12 h-12 absolute right-6 -bottom-4 rotate-180"
              />
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}
